import { InjectionToken } from '@angular/core';

export const RETURN_TO_INVENTORY_DIALOG = new InjectionToken<any>('RETURN_TO_INVENTORY_DIALOG');
